export class RotationsAction {
  static readonly type = '[Rotations] Add item';
  constructor(public payload: string) { }
}
export class GetRotationsAction {
  static readonly type = '[Rotations] Get Rotations';
  constructor(public payload: string) { }
}
export class GetRotationsTrackAction {
  static readonly type = '[Rotations] Get Rotations By Single Track';
  constructor(public payload: string) { }
}
export class GetRotationByStationAction {
  static readonly type = '[Rotations] Get Rotations By StationID';
  constructor(public payload: string) { }
}
export class GetRotationsStationsByExamAction {
  static readonly type = '[Rotations] Get Rotations Station By Exam';
  constructor(public payload: string) { }
}
export class GetRotationsTracksAction {
  static readonly type = '[Rotations] Get Rotations By Tracks';
  constructor(public payload: string) { }
}
export class GetStationsByTrackAction {
  static readonly type = '[Rotations] Get Stations By Tracks';
  constructor(public payload: string) { }
}
export class GetRotationsStationsAction {
  static readonly type = '[Rotations] Get Rotations Station';
  constructor(public payload: string) { }
}
export class GenerateRotationsAction {
  static readonly type = '[Rotations] Generate Rotations';
  constructor(public payload: string) { }
}

export class AddRotationAction {
  static readonly type = '[Rotations] Add Rotation';
  constructor(public payload: { examId: string, stationId: string, applicationId: string }) { }
}
